<template>
  <CCard>
    <CCardHeader style="background:#1a3665;color:white" class="d-flex align-items-center font-weight-bold">
      Master Kupon      
       <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"        
        class="btn-md ml-auto button-md-block px-3"
        @click="createData">Tambah</CButton>
      </template>
      <template v-else>
      <CButton
        color="secondary"        
        class="btn-md ml-auto button-md-block px-3"
        disabled>Tambah</CButton>
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            v-model.number="pageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kode_kupon="{item}">
              <td
                class="py-2 text-left font-weight-bold"
              >{{item.kode_kupon ? item.kode_kupon : "-"}}</td>
            </template>
            <template #nama_kupon="{item}">
              <td class="py-2 text-left">{{item.nama_kupon ? item.nama_kupon : "-"}}</td>
            </template>
            <template #persentase_potongan="{item}">
              <td
                class="py-2 text-center"
              >{{item.persentase_potongan ? item.persentase_potongan : "-"}} %</td>
            </template>
            <template #nama_level="{item}">
              <td class="py-2 text-left">{{item.nama_level ? item.nama_level : "-"}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2 text-center">{{item.nama_kategori ? item.nama_kategori : "-"}}</td>
            </template>
            <template #tanggal_mulai="{item}">
              <td class="py-2 text-center">{{item.tanggal_mulai ? item.tanggal_mulai : "-"}}</td>
            </template>
            <template #tanggal_expired="{item}">
              <td class="py-2 text-center">{{item.tanggal_expired ? item.tanggal_expired : "-"}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Ubah'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
                <template v-else>
                <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>      
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="kode_kupon" class="font-weight-bold">Kode Kupon</label>
                    <input
                      type="text"
                      class="form-control"
                      id="kode_kupon"
                      placeholder="Masukkan Kode Kupon"                      
                      v-model="formData.kodeKupon"
                      :class="{
                        'is-invalid': $v.formData.kodeKupon.$error,                     
                      }"
                      @input="setKodeKupon($event.target.value)"
                    />                    
                  </div>
                  <div class="form-group col-md-12">
                    <label for="nama_kupon" class="font-weight-bold">Nama Kupon</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_kupon"
                      required
                      placeholder="Masukkan Nama Kupon"
                      v-model="formData.namaKupon"
                      :class="{
                        'is-invalid': $v.formData.namaKupon.$error,                     
                      }"
                      @input="setNamaKupon($event.target.value)"
                    />                    
                  </div>
                  <div class="form-group col-md-12">
                    <label for="nama_cabang" class="font-weight-bold">Tipe Keanggotaan</label>
                    <multiselect
                      label="namaKategori"
                      placeholder="Pilih Tipe Keanggotaan"
                      @input="pilihKategori"
                      v-model="multi_kategori"
                      :options="kategoriAnggota"                      
                    ></multiselect>                    
                  </div>
                  <div class="form-group col-md-12">
                    <label for="kode_cabang" class="font-weight-bold">Peruntukan</label>
                    <multiselect
                      label="namaLevel"
                      placeholder="Pilih Level"
                      @input="pilihLevel"
                      v-model="multi_level"
                      :options="Level"
                      class="is-invalid"
                    ></multiselect>                    
                  </div>
                  <div class="form-group col-md-12">
                    <label for="persentase_potongan" class="font-weight-bold">Persentase Potongan</label>
                     <TextField
                        myclass="form-control"
                        id="id_kupon"
                        placeholder="Masukkan persentase" 
                        :maxlength="3"                        
                        :required="true" 
                        characterAllow="1234567890"
                        v-model="formData.persentasePotongan" 
                        :class="{
                          'is-invalid': $v.formData.persentasePotongan.$error,
                        }"
                    />
                    <span class="text-danger" v-if="$v.formData.persentasePotongan.$model > 100">
                      *Persentase tidak boleh lebih dari 100
                    </span>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="tgl_mulai" class="font-weight-bold">Tanggal Mulai</label>
                    <input
                      type="date"                      
                      class="form-control"
                      required
                      id="tgl_mulai"
                      placeholder="Masukkan Tanggal"
                      v-model="formData.tanggalMulai"
                      :min="today"
                      :class="{
                        'is-invalid': $v.formData.tanggalMulai.$error,                     
                      }"
                    />                    
                  </div>
                  <div class="form-group col-md-6">
                    <label for="tgl_exp" class="font-weight-bold">Tanggal Expired</label>
                    <input
                      type="date"                      
                      class="form-control"
                      id="tgl_exp"
                      required
                      placeholder="Masukkan Tanggal"
                      v-model="formData.tanggalExpired"
                      @click="triggerValidationExpired"
                      :min="today"
                      :class="{
                        'is-invalid': $v.formData.tanggalExpired.$error,
                      }"
                    />
                    <span class="text-danger" v-if="$v.formData.tanggalExpired.$error">
                      *Kurang dari tanggal mulai
                    </span>
                  </div>
                </div>
                <CCol sm="12" class="px-0">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        required
                        id="aktif"
                        value="1"
                        v-model="formData.status"                        
                      />
                      <label class="custom-control-label" for="aktif">Aktif</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        id="tidak_aktif"
                        value="0"
                        required
                        v-model="formData.status"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                    </div>
                  </div>
                  <span v-if="$v.formData.status.$error" class="text-danger">
                    *Mohon pilih status
                  </span>
                </CCol>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>          
        </template>
        <template #footer>
          <CButton @click="closeModal" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import { required, maxValue } from "vuelidate/lib/validators";
import KuponService from "../../services/datamaster/kupon.service";
import KategoriAnggotaService from "../../services/keanggotaan/kategori-anggota.service";
import LevelService from "../../services/datamaster/level.service";
import TextField from '../../components/formcomponent/TextField';
import { AlertUtils } from "../../mixins/AlertUtils"

const fields = [
  { key: "no" },
  { key: "kode_kupon" },
  { key: "nama_kupon" },
  { key: "persentase_potongan" },
  { key: "nama_level" },
  { key: "nama_kategori" },
  { key: "tanggal_mulai" },
  { key: "tanggal_expired", label: "Tanggal Berakhir" },
  { key: "status", _style: " text-align: center" },
  { key: "aksi", _style: "width:12%; text-align: center" }
];

import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";

export default {
  components: { DateRangePicker, TextField },
  mixins : [AlertUtils],
  name: "master-kupon",
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("en-US", options).format(value);
    }
  },
  data() {
    return {      
      multi_kategori: [],
      multi_level: [],
      items: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      kategoriAnggota: [],
      Level: [],
      opens: "center",
      minDate: "2019-05-02 04:00:00",
      maxDate: "2020-12-26 14:00:00",
      dateRange: {
        startDate: "2019-12-10",
        endDate: "2019-12-20"
      },
      show_ranges: true,
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showDropdowns: true,
      autoApply: false,
      showWeekNumbers: true,
      linkedCalendars: true,
      alwaysShowCalendars: true,
      timeout : null,
      actionPost: "",
      search : "",
      pageSize : 10,
      today: '',
      indexed : '',
      no : 1,
      validatePersentase: false,
      validatePersentaseTitle: '',
      formData: {
        kodeKupon: "",
        namaKupon: "",
        tipeKeangotaan: "",
        persentasePotongan: "",
        max: '3',
        peruntukan : "",
        namaKupon: "",
        tanggalMulai: new Date().toISOString().slice(0, 10),
        tanggalExpired: new Date().toISOString().slice(0, 10),
        status: "",
        idKupon: ""
      },
      pagination: {
        totalPages: 0
      },
      fileName: "Choose File...",
      fields,
      currentPage: 1,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: [],
      classs : this.class,
      role_status : null,
    }
  },

  validations: {
    formData: {      
      kodeKupon: { required },
      namaKupon: { required },
      tipeKeangotaan: { required },
      persentasePotongan: { 
        required,
        maxValue: maxValue(100)
      },
      peruntukan: { required },
      tanggalMulai: { required },
      tanggalExpired: { 
        required,
        isAfterDate(val, { tanggalMulai }) {
          return new Date(val) >= new Date(tanggalMulai);
        }
      },
      status: { required }
    },
  },

  watch: {
    search: function (val) {
       clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function(val) {
      // alert(val-1);  
      var page = val - 1;
      this.indexed = page * this.pageSize;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    },
    myModal: function() {
      if(!this.myModal) {
        this.clearValidation();
      }
    }
  },

  mounted() {

    // comment console console.log(this.baseUrl);
    this.getData("0", this.pageSize, this.search);
    this.getKategoriAnggota();
    this.getLevel();
    this.today = moment().format("YYYY-MM-DD")
    this.roleData();
  },

  methods: {
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { 
          $event.preventDefault();
      }
    },

    triggerValidationExpired() {
      this.$v.formData.tanggalExpired.$touch();
    },

    updateValue(event) {
      const value = event.target.value      
      if (String(value).length <= 10) {
        this.formData.persentasePotongan = value
      }
      this.$forceUpdate()
    },

    setKodeKupon(value) {
      this.formData.kodeKupon = value;
      this.$v.formData.kodeKupon.$touch();
      if(!this.$v.formData.kodeKupon.$error) {
        document.getElementById("kode_kupon").classList.add("is-valid")
      }
    },

    setNamaKupon(value) {
      this.formData.namaKupon = value;
      this.$v.formData.namaKupon.$touch();
      if(!this.$v.formData.namaKupon.$error) {
        document.getElementById('nama_kupon').classList.add('is-valid');
      }
    },

    pilihKategori(value) {
      this.formData.tipeKeangotaan = value.idKategoriAnggota;
      this.$v.formData.tipeKeangotaan.$touch();
    },

    pilihLevel(value) {
      this.formData.peruntukan = value.idLevelAnggota
      this.$v.formData.peruntukan.$touch();
    },

    changePageSize(e) {      
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
      
    getKategoriAnggota() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          this.kategoriAnggota = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log("gagal mengambil data kategori anggota");
          // comment console console.log(error);
        });
    },

    getLevel() {
      LevelService.getAllLevel()
        .then(response => {
          this.Level = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log("gagal mengambil data level");
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      var vm = this;

      this.formData.tipeKeangotaan = event.idKategoriAnggota;
    },

    pageChange() {
      this.getData(currentPage);
    },

    updateValues(values) {
      // comment console console.log("event: update", { ...values });
      this.dateRange.startDate = moment(values.startDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.dateRange.endDate = moment(values.endDate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },

    checkOpen(open) {
      // comment console console.log("event: open", open);
    },

    dateFormat(classes, date) {
      let yesterday = moment().subtract(1, "day");
      if (!classes.disabled) {
        classes.disabled = moment(date).isSame(yesterday, "day");
      }
      return classes;
    },

    deleteData(item, index) {
      var vm = this;

      vm.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            KuponService.deleteKupon(item.id_kupon)
              //then kalau responsenya berhasil
              .then(response => {                
                vm.alertDeleteSuccess();
                vm.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                vm.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },

    toggleDetails(item) {
      this.$set(this.items[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      KuponService.getKupon(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();          
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData.kodeKupon = '';
      this.formData.namaKupon = ''
      this.formData.tipeKeangotaan = '' 
      this.formData.peruntukan = '' 
      this.formData.persentasePotongan = '' 
      this.formData.tanggalMulai  = '' 
      this.formData.tanggalExpired = ''
      this.formData.status  = '' 
      this.formData.idKupon  = '' 
      this.multi_kategori = []
      this.multi_level = []
      this.actionPost = "insert";
      this.title = "Tambah";
      
    },

    updateData(item, index) {
      this.myModal = true;
      
      this.formData.kodeKupon = item.kode_kupon;
      this.formData.namaKupon = item.nama_kupon
      this.formData.tipeKeangotaan = item.tipe_keangotaan 
      this.formData.peruntukan = item.peruntukan 
      this.formData.persentasePotongan = item.persentase_potongan 
      this.formData.tanggalMulai  = item.tanggal_mulai 
      this.formData.tanggalExpired = item.tanggal_expired
      this.formData.status  = item.status 
      this.formData.idKupon  = item.id_kupon 

      this.actionPost = "update";
      this.title = "Edit";
      this.multi_kategori = [
        {
          namaKategori: item.nama_kategori
        }
      ];

      this.multi_level = [
        {
          namaLevel: item.nama_level
        }
      ];
    },

    postData() {
      this.$v.$touch();      
      if (this.actionPost == "insert") {
        if (this.$v.$invalid) {
          return;
        } else {
          this.insertData(this.formData);
        }           
        // }           
      } else if (this.actionPost == "update") {
        if (this.$v.$invalid) {
          return;
        } else {          
          this.putData();
        } 
      }      
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });      
      var vm = this;      
      var tglMulai = formData.tanggalMulai.split("-"); // ex input "2010-01-18"
      formData.tanggalMulai = tglMulai[0] + "-" + tglMulai[1] + "-" + tglMulai[2]; //ex out: "18/01/10"
      var tglExp = formData.tanggalExpired.split("-"); // ex input "2010-01-18"
      formData.tanggalExpired = tglExp[0] + "-" + tglExp[1] + "-" + tglExp[2]; //ex out: "18/01/10"
                  
      KuponService.postKupon(formData)
        .then(response => {
          loader.hide();      
          vm.myModal = false;
          vm.clearValidation();
          vm.alertSuccess();
          vm.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          loader.hide();
          
          vm.alertError(error.response.data.message);
          // comment console console.log(error);
          // vm.alertError();
        });
    },

    putData() {      
      KuponService.putKupon(this.formData)
        .then(response => {
          this.myModal = false;
          this.alertEditSuccess();
          this.clearValidation();          
          this.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    closeModal() {
      this.myModal = false      
      this.clearValidation();
    },

    clearValidation() {
    this.$v.$reset();
    document.getElementById('kode_kupon').classList.remove('is-valid');
    document.getElementById('nama_kupon').classList.remove('is-valid');
    
  },
   roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
